import ApiServices from '@/services/api'

const FETCH_ALL_SITES = ({ commit }) => {
  return ApiServices.getAllSites()
    .then(response => {
      commit('setAllSites', response)
      return response
    })
}

const FETCH_USER_PREFERENCES = ({ commit }) => {
  return ApiServices.getUserSitePreferences()
    .then(response => {
      commit('setUserPreferences', response)
      return response
    })
}

const UPDATE_USER_PREFERENCES = ({ commit }, siteIds) => {
  return ApiServices.updateUserSitePreferences({ site_ids: siteIds })
    .then(response => {
      commit('setUserPreferences', response)
      return response
    })
}

export default {
  FETCH_ALL_SITES,
  FETCH_USER_PREFERENCES,
  UPDATE_USER_PREFERENCES
}



// WEBPACK FOOTER //
// ./src/store/modules/sitePreferences/actions.js